const config = {
  BACKEND_BASE_URL: process.env.REACT_APP_BACKEND_URL || "http://localhost:5000",
  PUBLIC_FRONTEND_BASE_URL: process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000",
  ADMIN_URL: process.env.REACT_APP_ADMIN_URL || "http://localhost:3001",
  TERMS_URL_GR: process.env.REACT_APP_TERMS_URL_GR || "",
  TERMS_URL_EN: process.env.REACT_APP_TERMS_URL_EN || "",
  PRIVACY_URL_GR: process.env.REACT_APP_PRIVACY_URL_GR || "",
  PRIVACY_URL_EN: process.env.REACT_APP_PRIVACY_URL_EN || "",
};
export default config;

